(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cleani-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cleani-community')) {
    customElements.define('cleani-community', class extends HTMLElement {
      connectedCallback() {
        this.gallery = this.querySelector('.cleani-community__gallery');
        this.buttons = [...this.querySelectorAll('[data-direction]')];
        this.update = () => {
          const max = this.gallery.scrollWidth - this.gallery.clientWidth;
          const left = Math.max(0, this.gallery.scrollLeft);
          this.buttons[0].disabled = left <= 2;
          this.buttons[1].disabled = left >= max - 2;
          this.style.setProperty('--community-progress', `${max > 0 ? Math.min(100, (left + this.gallery.clientWidth) / this.gallery.scrollWidth * 100) : 100}%`);
        };
        this.navigate = event => {
          const button = event.target.closest('[data-direction]');
          if (!button) return;
          const tile = this.gallery.querySelector('.cleani-community__tile');
          if (!tile) return;
          const step = tile.getBoundingClientRect().width + Number.parseFloat(getComputedStyle(this.gallery).gap);
          this.gallery.scrollBy({ left: Number(button.dataset.direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.addEventListener('click', this.navigate);
        this.gallery.addEventListener('scroll', this.update, { passive: true });
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.gallery);
        this.update();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.navigate);
        this.gallery.removeEventListener('scroll', this.update);
        this.resizeObserver.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cleani-reference-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cleani-footer-layout')) {
    customElements.define('cleani-footer-layout', class extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(min-width: 750px)');
        this.sync = () => this.querySelectorAll('details').forEach(details => { details.open = this.media.matches; });
        this.preventDesktopToggle = event => { if (this.media.matches && event.target.closest('summary')) event.preventDefault(); };
        this.sync();
        this.media.addEventListener('change', this.sync);
        this.addEventListener('click', this.preventDesktopToggle);
      }
      disconnectedCallback() {
        this.media.removeEventListener('change', this.sync);
        this.removeEventListener('click', this.preventDesktopToggle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
